import React, { useState, useEffect, useReducer } from 'react'
import {
  Col,
  Panel,
  Row,
  IconButton,
  Icon,
  ButtonGroup,
  Message,
  ControlLabel,
  Input,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import notification from '../../utils/notification'
import ProjectCommentRecordTable from './ProjectCommentRecordTable'
import { saveCommentation } from '../../redux/actions/subprojectCommentation'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import { getMaxLengthData, isRequired, isValidators } from '../../utils/ValidatorUtils'
import ShowLimitLength from '../../components/utils/ShowLimitLength'

export default function ProjectCommentsRecordWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [comment, setComment] = useState()
  const [commentLength, setCommentLength] = useState(0)

  const projectCode = sessionStorage.getItem('projectCode')
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    setFormSchema(props.schema)
  }, [props])

  const onSubmit = (data) => {
    console.log('data', data)

    let request = {
      projectCode: projectCode,
      projectVersionId: projectId,
      notesInput: data.notesInput,
    }
    handleCallService(request)
  }

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)

    try {
      let response = await saveCommentation(request, projectId, projectCode)
      if (response) {
        setValue(formSchema?.form?.formInput?.notesInput?.name, '')
        setComment()
        setCommentLength(0)
        setFormSchema(response)

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={'บันทึกการให้ความเห็นต่อโครงการ'} bordered>
        {formSchema?.form?.formInput?.notesInput && (
          <Row>
            <ControlLabel
              className={classNames(
                isRequired(formSchema.form.formInput.notesInput.validators) && 'required'
              )}
            >
              {formSchema.form.formInput.notesInput.label}
            </ControlLabel>
            <ErrorMessage error={errors.notesInput} />
            <Input
              rows={10}
              componentClass="textarea"
              placeholder={formSchema.form.formInput.notesInput.label}
              defaultValue={formSchema.form.formInput.notesInput.value}
              name={formSchema.form.formInput.notesInput.name}
              inputRef={register(isValidators(formSchema.form.formInput.notesInput.validators))}
              maxLength={
                getMaxLengthData(formSchema.form.formInput.notesInput.validators)?.value || 1000
              }
              onChange={(value) => {
                setComment(value)
                setCommentLength(value.length)
              }}
            />
            <ShowLimitLength
              textLength={commentLength}
              maxLength={
                getMaxLengthData(formSchema.form.formInput.notesInput.validators)?.value || 1000
              }
            />
          </Row>
        )}
        <br />
        {isError && <Message showIcon type="error" description={isError} />}
        <Row>
          <Col style={{ textAlign: 'end' }}>
            <SaveButton onClick={handleSubmit(onSubmit)}>{'บันทึก'}</SaveButton>
          </Col>
        </Row>
      </Panel>
      <br />
      <Panel shaded collapsible defaultExpanded bordered header={'ประวัติการให้ความเห็นต่อโครงการ'}>
        <ProjectCommentRecordTable schema={formSchema} data={formSchema?.form?.data} />
      </Panel>
    </>
  )
}
